// extracted by mini-css-extract-plugin
export default {"container-fluid":"LikeSection_container-fluid__GPkeZ","like-title":"LikeSection_like-title__iFCIo"};